import type { WbeTheme } from "@api-contracts/sites/wbe/theme";

const PARAM = "theme";
const STORAGE_KEY = "wbe-theme-preview";
const HEX = /^[0-9a-fA-F]{6}$/;
/** Trailing marker for a preview with rounded corners turned off. */
const SQUARE = "square";

/** `?theme=<bg>,<primary>,<accent>[,square]` with bare hex; anything else is ignored. */
export const parsePreviewTheme = (raw: string | null): WbeTheme | null => {
  const [bg, primary, accent, ...rest] = raw?.split(",") ?? [];
  const colours = [bg, primary, accent];
  if (!colours.every((p) => p !== undefined && HEX.test(p))) return null;
  if (rest.length > 1 || (rest.length === 1 && rest[0] !== SQUARE)) return null;
  const [backgroundColor, primaryColor, accentColor] = colours.map(
    (p) => `#${p.toUpperCase()}`,
  );
  return {
    backgroundColor,
    primaryColor,
    accentColor,
    roundedCorners: rest[0] !== SQUARE,
  };
};

/**
 * The unsaved colours the PMS theme tab opens a site's WBE with. Kept per site in
 * sessionStorage so they survive navigation inside the app and vanish with the tab.
 */
export const readPreviewTheme = (
  search: string,
  site: string,
  storage?: Storage,
): WbeTheme | null => {
  const key = `${STORAGE_KEY}:${site}`;
  const raw = new URLSearchParams(search).get(PARAM);
  const fromUrl = parsePreviewTheme(raw);
  try {
    if (fromUrl) storage?.setItem(key, raw as string);
    return fromUrl ?? parsePreviewTheme(storage?.getItem(key) ?? null);
  } catch {
    return fromUrl;
  }
};
